import classNames from 'classnames'
import Markdown from './Markdown'
import { ArrowRight, Copy, Search } from 'wujieai-react-icon'
import { MyImage } from '~/components/ui/MyImage'
import copy from 'copy-to-clipboard'
import { message } from 'antd'
import { IMessage, ISearchResult, searchResultsAtom } from '../atom'
import { useState } from 'react'
import { ArrowDown, Warning } from 'wujieai-react-icon'
import { useAtom } from 'jotai'
import { ChatRole } from '~/graphqls/customType'
const isDev = process.env.NEXT_PUBLIC_NODE_ENV === 'development'

export default function Message({ msg }: { msg: IMessage }) {
  return (
    <div
      className={classNames('py-2', {
        'ml-auto w-max': msg.role === ChatRole.USER,
      })}
    >
      {msg.role === ChatRole.ASSISTANT ? (
        <AssistantMessage msg={msg} />
      ) : (
        <UserMessage msg={msg} />
      )}
    </div>
  )
}

function AssistantMessage({ msg }: { msg: IMessage }) {
  const [hideReason, setHideReason] = useState(false)

  if (msg.error) {
    return (
      <div className="p-2 bg-neutral-200 rounded-lg text-sm flex items-center gap-1">
        <Warning size={16} className="text-error" />
        <div>
          {isDev
            ? `${msg.conversationId}, ${msg.id}: ${msg.errorReason}`
            : '服务器繁忙'}
        </div>
      </div>
    )
  }

  if (!msg.thinkingEnabled && !msg?.content?.length) {
    return null
  }

  if (msg.thinkingEnabled && !msg.reasoning?.length && !msg?.content?.length) {
    return null
  }

  return (
    <>
      <div className="p-4 bg-neutral-200 rounded-lg space-y-1">
        {msg.thinkingEnabled && (
          <>
            <div
              className="flex items-center space-x-1 font-semibold text-xs text-neutral-500 cursor-pointer"
              onClick={() => {
                setHideReason(!hideReason)
              }}
            >
              <MyImage
                src={'/images/deepseek/assistant.svg'}
                className="w-[14px] h-[14px] block  relative"
              />
              {msg.thinkingTime !== 0 && (
                <div>已深度思考（用时 {msg.thinkingTime} 秒）</div>
              )}
              {msg.thinkingTime === 0 && !!msg.reasoning && !msg.done && (
                <div>深度思考中</div>
              )}
              <div
                className={classNames(
                  ' transition-transform flex',
                  hideReason ? ' rotate-180' : ''
                )}
              >
                <ArrowDown size={20} />
              </div>
            </div>
            {msg.reasoning && !hideReason && (
              <div className="border-l pl-1.5 border-neutral-300 text-neutral-400">
                <div className="prose prose-sm prose-neutral1 prose-invert !max-w-full prose-p:my-3 prose-hr:my-5">
                  <Markdown>{msg.reasoning}</Markdown>
                </div>
              </div>
            )}
          </>
        )}
        <div className="prose prose-sm prose-neutral prose-invert !max-w-full prose-p:my-3 prose-hr:my-5">
          <Markdown>{msg.content}</Markdown>
        </div>
        {msg.done && !!msg.content?.length && (
          <div className="flex gap-1 items-center text-xs text-neutral-500">
            <div
              className="w-[14px] h-[14px] cursor-pointer"
              onClick={() => {
                copy(msg.content)
                message.destroy()
                message.success('内容已复制')
              }}
            >
              <Copy size={14} />
            </div>
            <div className="w-px h-[14px] bg-neutral-300 mx-1"></div>
            <div>内容由AI生成</div>
          </div>
        )}
      </div>
      {!!msg.searchResults?.length && (
        <SearchMessage results={msg.searchResults} />
      )}
    </>
  )
}

function UserMessage({ msg }: { msg: IMessage }) {
  return (
    <div className="px-4 py-2 bg-primary text-white rounded-lg text-sm whitespace-pre-wrap break-words max-w-[800px] selection:bg-[#4A3195]">
      {msg.content}
    </div>
  )
}

function SearchMessage({ results }: { results: ISearchResult[] }) {
  const [, setSearchResults] = useAtom(searchResultsAtom)

  return (
    <div
      className="px-4 py-2 bg-neutral-200 rounded-lg flex items-center mt-6 w-max gap-1 cursor-pointer"
      onClick={() => {
        setSearchResults(prev => {
          if (prev === results) {
            return null
          }
          return results
        })
      }}
    >
      <Search size={14} />
      <div>已搜索到 {results.length} 个网页</div>
      <ArrowRight size={14} />
    </div>
  )
}
